<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Order Status(ApprovalStatus)">
          <dict-select
            v-decorator="[ 'approvalStatus']"
            :dict-code="DICT_CODE.ORDER_STATUS"
            :begin="[{ value: '', label: 'All', labelEn: 'All' }]"
            :placeholder="$t('select')"
          />
        </a-form-item>
<!--        <a-form-item-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--          label="Loan status">-->
<!--          <dict-select-->
<!--            v-decorator="[ 'loanStatus']"-->
<!--            :dict-code="DICT_CODE.LOAN_STATUS"-->
<!--            :begin="[{ value: '', label: 'All', labelEn: 'All' }]"-->
<!--            :placeholder="$t('select')"-->
<!--          />-->
<!--        </a-form-item>-->
<!--        <a-form-item-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--          label="Overdue status">-->
<!--          <dict-select-->
<!--            v-decorator="[ 'overdueStatus']"-->
<!--            :dict-code="DICT_CODE.OVERDUE_STATUS"-->
<!--            :begin="[{ value: '', label: 'All', labelEn: 'All' }]"-->
<!--            :placeholder="$t('select')"-->
<!--          />-->
<!--        </a-form-item>-->
<!--        <a-form-item-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--          label="Settlement status">-->
<!--          <dict-select-->
<!--            v-decorator="[ 'settleStatus']"-->
<!--            :dict-code="DICT_CODE.SETTLE_STATUS"-->
<!--            :begin="[{ value: '', label: 'All', labelEn: 'All' }]"-->
<!--            :placeholder="$t('select')"-->
<!--          />-->
<!--        </a-form-item>-->
<!--        <a-form-item-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--          label="Application amount">-->
<!--          <a-input placeholder="Please enter application amount" v-decorator="[ 'applyAmt']"/>-->
<!--        </a-form-item>-->
<!--        <a-form-item-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--          label="Interest">-->
<!--          <a-input placeholder="Please enter interest" v-decorator="[ 'interest']"/>-->
<!--        </a-form-item>-->
<!--        <a-form-item-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--          label="Deduction amount">-->
<!--          <a-input placeholder="Please enter deduction amount" v-decorator="[ 'deductionFee']"/>-->
<!--        </a-form-item>-->
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { editInstallOrderStatusMainForTest} from '@/webpublicapi/order'
import DictSelect from '../../modules/DictSelect';


// duplicateCheck
export default {
  name: 'TestInstallOrderModalT',
  components: {
    DictSelect,
  },
  data () {
    return {
      value: 1,
      title: 'Action',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({})
    },
    edit (record) {
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.model.approvalStatus=String(this.model.approvalStatus)
        this.model.loanStatus=String(this.model.loanStatus)
        this.model.overdueStatus=String(this.model.overdueStatus)
        this.model.settleStatus=String(this.model.settleStatus)
        this.form.setFieldsValue(pick(this.model,  'approvalStatus'))
      })
    },
    // Confirm
    handleOk () {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj
          console.log(formData)
          obj = editInstallOrderStatusMainForTest(formData)
          obj.then((res) => {
            if (res.code === 1000) {
              this.$message.success(res.msg)
              this.$emit('ok')
            } else {
              this.$message.warning(res.msg)
            }
          }).finally(() => {
            this.confirmLoading = false
            this.close()
          })
        }
      })
    },
    // Close
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
